<script>
import Loading from '../../components/loading.vue';
import MineOption from '../../components/select/mineOption.vue';
import MineSelect from '../../components/select/mineSelect.vue';

export default {
    name: "afterSale",
    data() {
        return {
            isLoading: false,
            detail: {
                id: 1,
                image: '',
                time: '2025-06-26',
                order_code: '1234567899874562',
                name: '金满勇限量联名手机壳',
                count: 1,
                price: '45.00',
                isShowLogistics: false,
            },
            type: [
                { text: '退款退货' },
            ],
            typeValue: '退款退货',
            reason: [
                { text: '质量问题' },
            ],
            reasonValue: '质量问题',
            content: '',
            images: [],
        };
    },
    computed: {},
    components: {
        Loading,
        MineSelect,
        MineOption,
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        // 服务类型
        typeChoose(item) { 
            this.typeValue = item.text;
        },
        // 退款原因
        reasonChoose(item) { 
            this.reasonValue = item.text;
        },
        // 获取文件信息
        getFileData(event) {
            const file = this.$refs.file.files;
            Object.entries(file).forEach(([key, value]) => {
                // 读取文件
                let reader = new FileReader();
                reader.readAsDataURL(value);
                reader.onload = (result) => { 
                    this.images.push({
                        path: reader.result,
                        isLoading: false,
                    });
                    this.$previewRefresh();
                    // console.log(result)
                    // console.log(reader.result)
                    // this.image = reader.result;
                }
            });
        },
    },
};
</script>

<template>
    <div class="after_sale">
        <p class="title">售后服务</p>
        <div class="loading_wrap" v-if="isLoading">
            <Loading/>
        </div>
        <div class="order_list" v-else>
            <div class="item thead">
                <div class="tr">
                    <div class="td">退货商品</div>
                    <div class="td">订单编号</div>
                    <div class="td">退款金额</div>
                    <div class="td">数量</div>
                </div>
            </div>
            <div class="item">
                <div class="tr">
                    <div class="td">
                        <div class="info">
                            <router-link class="cover" :style="`background-image: url(${detail.image});`" :to="`/shop/detail?id=${detail.id}`"></router-link>
                            <div class="wrapper">
                                <p class="name">
                                    <router-link :to="`/shop/detail?id=${detail.id}`">{{detail.name}}</router-link>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="td layout_flex_center">{{ detail.order_code }}</div>
                    <div class="td layout_flex_center">RMB {{detail.price}}</div>
                    <div class="td layout_flex_center">{{ detail.count }}</div>
                </div>
            </div>
        </div>
        <div class="form">
            <div class="item">
                <p class="name">服务类型：*</p>
                <MineSelect class="select">
                    <template v-slot:value>{{ typeValue }}</template>
                    <MineOption v-for="(item, index) in type" :key="index" :is-active="typeValue == item.text" @click="typeChoose(item)">{{ item.text }}</MineOption>
                </MineSelect>
            </div>
            <div class="item">
                <p class="name">退款原因：*</p>
                <MineSelect class="select">
                    <template v-slot:value>{{ reasonValue }}</template>
                    <MineOption v-for="(item, index) in reason" :key="index" :is-active="reasonValue == item.text" @click="reasonChoose(item)">{{ item.text }}</MineOption>
                </MineSelect>
            </div>
            <div class="item">
                <p class="name">退款说明：*</p>
                <textarea placeholder="退款说明" v-model="content"></textarea>
            </div>
            <div class="item">
                <p class="name">第三方证明：*</p>
                <div class="images">
                    <div class="image" v-for="(item, index) in images" :key="index" :style="`background-image: url(${item.path});`">
                        <img :src="item.path" alt="" preview="images"/>
                        <div class="btn_close"></div>
                        <Loading v-if="item.isLoading"/>
                    </div>
                    <input type="file" ref="file" style="display: none;" accept="image/*" multiple @change="getFileData"/>
                    <div class="image add" @click="$refs.file.click()"></div>
                </div>
            </div>
        </div>
        <div class="more_info">
            <p>备注：非质量问题不退不换，请谨慎购买，质量问题需提供第三方质检机构证明，提交后我方会尽快确认是否质量问题，并在第一时间以邮件或短信与您确认。请勿在确认前寄回，我司有权拒签货物。由于商品为艺术藏品和商品，限量或联名款，货物到达您手上请务必拆封检查，如遇货物在物流中的损毁，请立即拒绝签售，如您未检查并签售，我方不承担任何商品损坏所导致的损失。我方确认退换货申请后，请按照以上地址填写并包装立即寄回。如在通过后3个工作日未能寄出，退货申请将自动撤销，撤销后若超出保障期，将无法再次发起售后申请。请务必了解。</p>
            <p>由于商品质量原因导致的任何问题，我方承担所有国内物流费用。</p>
        </div>
        <div class="form">
            <div class="item justify_end">
                <div class="btn">提交</div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.after_sale{
    .more_info{
        padding: 0 .1rem;
        font-size: .14rem;
        line-height: 1.5;
    }
    .order_list{
        .tr{
            .td{
                flex: 1;
                &:nth-of-type(1){
                    flex: none;
                    width: 38%;
                }
            }
        }
        .item{
            border-bottom: 1px solid #ebebeb;
            &.thead{
                border-bottom: none;
            }
        }
    }
    .form{
        padding: .3rem .1rem;
        .item{
            .name{
                width: 1.1rem;
            }
            .select{
                width: 2.2rem;
                flex: none;
            }
            .images{
                display: flex;
                flex-wrap: wrap;
                gap: .2rem;
                .image{
                    width: 1.2rem;
                    height: 1.2rem;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: cover;
                    position: relative;
                    img{
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        opacity: 0;
                    }
                    .btn_close{
                        width: .4rem;
                        height: .4rem;
                        position: absolute;
                        top: 0;
                        right: 0;
                        background: rgba($color: #000000, $alpha: .5);
                        cursor: pointer;
                        &::before,
                        &::after{
                            content: "";
                            display: block;
                            width: 50%;
                            border-bottom: 1px solid #fff;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%) rotate(45deg);
                        }
                        &::after{
                            transform: translate(-50%, -50%) rotate(135deg);
                        }
                    }
                    .loading{
                        margin: 0;
                    }
                    &.add{
                        border: 1px solid var(--font_color);
                        position: relative;
                        &::before,
                        &::after{
                            content: "";
                            width: 50%;
                            border-bottom: 1px solid var(--font_color);
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                        }
                        &::after{
                            transform: translate(-50%, -50%) rotate(90deg);
                        }
                    }
                }
            }
        }
    }
}
</style>